import { __require as requireFunctionUncurryThis } from './node_modules-core-js-internals-function-uncurry-this.js';

var objectIsPrototypeOf;
var hasRequiredObjectIsPrototypeOf;

function requireObjectIsPrototypeOf () {
	if (hasRequiredObjectIsPrototypeOf) return objectIsPrototypeOf;
	hasRequiredObjectIsPrototypeOf = 1;
	var uncurryThis = requireFunctionUncurryThis();

	objectIsPrototypeOf = uncurryThis({}.isPrototypeOf);
	return objectIsPrototypeOf;
}

export { requireObjectIsPrototypeOf as __require };
//# sourceMappingURL=node_modules-core-js-internals-object-is-prototype-of.js.map
